
import testData from '../testData'
export default {
  data() {
    return {      
      forceSaveAlias: false
    }
  },
  created: function () {    
    this.startLoader()
    this.prefillAlias()
    this.getPhoneRequired().then(rep => {
      if (this.params.lastUserEntry) {
        //this.ibanValid = true 
        // last data entered by the user is recharged
        this.prefillForm(this.params.lastUserEntry)
        setTimeout(() => {
          this.stopLoader()
        }, 200)
      }
      else if (this.params.aliasId) { 
        // info from server, charge the local fields, deactivate input
        if (process.env.NODE_ENV !== 'production') {
          setTimeout(() => {
            this.prefillForm(testData.displayInfo)
            this.stopLoader()
          }, 2000)
        }
        else {
          if (!rep) throw new Error(this.$t('error_displayinfo'))
          const content = rep.content
          this.prefillForm(content)
          this.stopLoader()
        }
      }
      else if (this.params.details) {
        // this.ibanValid = true 
        this.prefillForm(this.params.details)
        setTimeout(() => {
          this.stopLoader()
        }, 200)
      }
      else if (this.params.mkpData && this.params.mkpData.details) {
        // this.ibanValid = true 
        this.prefillForm(this.params.mkpData.details)
        setTimeout(() => {
          this.stopLoader()
        }, 200)
      }
      else this.stopLoader()
    }).catch(err => {
      console.log(err)
      if (process.env.NODE_ENV !== 'production') {
        setTimeout(() => {
          this.prefillForm(testData.displayInfo)
          this.stopLoader()
        }, 200)
      }
      else this.stopLoader()
    })
  },  
  directives: {
    normalize: {
      bind: function (_el, _, vnode) {
        let el = _el.querySelector("input")
        if (!el) return
        el.transformNormal = function () {
          const start = el.selectionStart
          el.value = el.value ? el.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase() : el.value
          el.setSelectionRange(start, start)
          vnode.componentInstance.$emit('input', el.value?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase())
        }
        el.addEventListener('input', function () {
          el.transformNormal()
        })
      },
      unbind: function (_el) {
        let el = _el.querySelector("input")
        if (!el) return
        el.removeEventListener('input', el.transformNormal)
      }
    }
  },
  methods: {
    startLoader () {
      this.$emit('startLoader')
    },
    stopLoader () {
      this.$emit('stopLoader')
    },
    prefillForm (data) {
      this.name = data.lastName || ''
      this.firstName = data.firstName || '' 
      this.iban = data.iban || ''
      this.email = data.email || ''
      this.companyName = data.socialReason || ''
      this.address = data.address || ''
      this.address2 = data.state || ''
      this.city = data.city || ''
      if (this.countryByName && this.countryByAlpha2) {
        let country = this.countryByName(data.country) || this.countryByAlpha2(data.country)
        this.country =  country ? country.name : ''
      }
      else this.country = ''
      this.postalCode = data.postalCode || ''
      this.phoneNumber = (data.phoneNumber && data.phoneNumber.indexOf('00') === 0) ? data.phoneNumber.replace('00', '+') : (data.phoneNumber || '')
      this.province = data.province || data.state || ''
      let form = this.$refs.form
      if (form) form.validate()
    },
    prefillAlias () {
      let mkpData = this.params.mkpData
      if (!mkpData) return
      if (mkpData.registerAlias === '1') {
        this.forceSaveAlias = true
        this.saveAlias = true
        if (mkpData.alias) this.newAliasLabel = mkpData.alias.label
      }
    },
    getCountryID: function () {
      let country = this.sepaCountries.find(i => i.name === this.country)
      if (country) return country.id
      return ''
    },
    getCountryAlpha2: function () {
      let country = this.sepaCountries.find(i => i.name === this.country)
      if (country) return country.alpha2
      return ''
    },
    getCountryAlpha3: function () {
      let country = this.sepaCountries.find(i => i.name === this.country)
      if (country) return country.alpha3
      return ''
    },
    getPhoneRequired: function () {
      let _this = this
      return new Promise(function (resolve, reject) {
        try {
          let options = {
            paymentMethodTypeId: _this.params.methodTypeId,
            paymentMethodId: _this.params.methodId
          }
          if (_this.params.aliasId) options.aliasId = _this.params.aliasId
          _this.callSDDDisplayOptions(options).then(rep => {
            if (process.env.NODE_ENV !== 'production') {
              _this.testcount++
              let mockData = _this.testcount % 3 === 0 ? testData.displayOptions : testData.displayOptions
              _this.phoneRequired = mockData.otp === '1'
            }
            else {
              if (!rep) throw new Error(_this.$t('error_displayoptions'))
              const content = rep.content
              _this.phoneRequired = content.otp === '1'
            }
            resolve(rep)
          })
        } catch (ex) {
          _this.phoneRequired = false
          reject(ex)
        }  
      })
    }
  },
  computed: {
    ibanSepa: function () {
      return (this.iban.length > 1) ? this.isSepaIban(this.iban.slice(0,2)) : true
    },
    ibanRules: function () {
      let rules = [...this.rules.iban, 
        () => this.ibanSepa || this.$t('validation_iban_5')
      ]
      if (this.ibanUnknown) rules.push(() => this.$t('validation_iban_3'))
      return rules
    }
  },
  watch: {
    ibanHorsEU (newValue) {
      if (newValue) {        
        // for postalcode validation 
        if (this.country) this.onCountryUpdated(this.getCountryID(this.country))
      }
    }
  },
}